/* eslint-disable react/destructuring-assignment */
import { ErrorMessage } from 'formik';
import React, { Component } from 'react';
import UploadBrowseFile from '../../../components/BrowseFile/uploadBrowseFile.component';
import Input from '../../../components/Input/input.component';
import { formatarTelefone } from '../../../utils/telefoneHelper';
import WidgetModalForm, { ModalFormContext } from '../../../components/Modal/modalForm.component';
import Required from '../../../components/Required/required.component';
import SelectMulti from '../../../components/SelectMulti/selectmulti.component';
import centralDoacaoService from '../../../services/centralDoacaoService';
import MunicipioService from '../../../services/municipioService';
import UploadService from '../../../services/uploadService';
import { EditarOficioValidationSchema } from './editaOficio.modal.validate';

export default class EditaOficio extends Component {
	constructor(props) {
		super(props);
		this.state = {
			oficio: {
				...this.props.oficioProp,
				tipoOficio: this.props.oficioProp.municipio ? 'municipio' : 'entidade',
			},
			municipioSelecionado: this.props.oficioProp.municipio ? this.props.oficioProp.municipio : null,
			entidadeSelecionada: this.props.oficioProp.entidade ? this.props.oficioProp.entidade : null,
			municipios: [],
			entidades: [],
			files: [{
				source: 1,
				options: {
					type: 'limbo',
					file: {
						name: this.props.oficioProp.documento.nome,
						size: this.props.oficioProp.documento.size,
					},
				},
			}],
			frontOnlyFiles: true,
		};
	}

	async componentDidMount() {
		const allEntidades = await centralDoacaoService.findAllEntidadesSemPaginacao();
		this.setState({
			entidades: [...allEntidades.data.filter(entidade => !entidade.cancelado)],
		});
		const allMunicipios = await MunicipioService.findAll();
		this.setState({
			municipios: [...allMunicipios.data],
		});
	}

	onChangeMunicipio(item) {
		const newState = this.state;
		newState.municipioSelecionado = item.object;
		newState.oficio.municipio = item.object;
		newState.oficio.entidade = null;
		this.setState(newState);
	}

	onChangeEntidade(item) {
		const newState = this.state;
		newState.entidadeSelecionada = item.object;
		newState.oficio.entidade = item.object;
		newState.oficio.municipio = null;
		this.setState(newState);
	}

	/*
		Função para mudar o tipo de ofício. Não foi usado setFieldValue
		e sim um handleChange, pois ao atualizar o estado em qualquer handleChange,
		o tipoOficio era perdido, e sumiam os componentes dependentes dessa váriavel.
		Esta função também injeta novamente o arquivo anexado no componente de upload,
		caso o arquivo seja proveniente do back-end. Isso é feito para não causar
		erros no componente de upload.
	*/
	onChangeTipoOficio(event) {
		const {
			oficio, files, frontOnlyFiles, municipioSelecionado, entidadeSelecionada,
		} = this.state;

		this.setState({
			oficio: {
				...oficio,
				municipio: (event.target.value === 'municipio' && municipioSelecionado) ? municipioSelecionado : null,
				entidade: (event.target.value === 'entidade' && entidadeSelecionada) ? entidadeSelecionada : null,
				tipoOficio: event.target.value,
			},
			files: frontOnlyFiles ? [{
				source: 1,
				options: {
					type: 'limbo',
					file: {
						name: oficio.documento.nome,
						size: oficio.documento.size,
					},
				},
			}] : files,
		});
	}

	handlePosUploadAction = (documento) => {
		const { oficio } = this.state;
		this.setState({
			oficio: {
				...oficio,
				documento: documento.data.data,
			},
			frontOnlyFiles: false,
		});
	};

	render() {
		const {
			props: {
				isOpenEditar,
				handleCloseEditar,
				handleSubmitEditar,
			},
			state: {
				oficio,
				municipios,
				entidades,
				municipioSelecionado,
				entidadeSelecionada,
				files,
			},
		} = this;
		return (
			<WidgetModalForm
				textCancelar='Cancelar'
				textConfirmar='Salvar'
				initialValues={oficio}
				validationSchema={EditarOficioValidationSchema}
				title='Editar ofício'
				confirmar={handleSubmitEditar}
				isOpen={isOpenEditar}
				cancelar={handleCloseEditar}
				modalConfirmarFechar
				modalConfirmarCancelar
				modalConfirmarCancelarTitulo='Atenção!'
				modalConfirmarCancelarCorpo='Tem certeza que deseja cancelar? Todos os dados preenchidos serão perdidos.'
				iconCancelar='fas fa-times'
				iconConfirmar='fas fa-save'
				tamanho='lg'
			>
				<ModalFormContext.Consumer>
					{({ values, resetForm }) => (
						<React.Fragment>
							<div className='row'>
								<div className='col-md-12'>
									<label>
										O ofício é de um município ou de uma entidade? <Required />
									</label>
									<div className='form-group'>
										<div className='form-check form-check-inline'>
											<Input
												id='radio_1'
												name='tipoOficio'
												type='radio'
												className='form-check-input'
												value='municipio'
												onChange={(event) => {
													this.onChangeTipoOficio(event);
												}}
												checked={oficio.tipoOficio === 'municipio'}
											/>
											<label
												htmlFor='radio_1'
												className='form-check-label pointer-text'
											>
												Município
											</label>
										</div>

										<div className='form-check form-check-inline'>
											<Input
												id='radio_2'
												name='tipoOficio'
												type='radio'
												value='entidade'
												className='form-check-input'
												onChange={(event) => {
													this.onChangeTipoOficio(event);
												}}
												checked={oficio.tipoOficio === 'entidade'}
											/>
											<label
												htmlFor='radio_2'
												className='form-check-label pointer-text'
											>
												Entidade
											</label>
										</div>
									</div> {/* .form-group */}
								</div> {/* .col-md-12 */}
								<ErrorMessage
									name='tipoOficio'
									render={msg => (
										<span className='ml-3 text-danger'>
											{msg}
										</span>
									)}
								/>
							</div> {/* .row */}

							{/* EDIÇÃO DO OFICIO DE MUNICIPIO */}
							{oficio.tipoOficio === 'municipio'
								&& (
									<React.Fragment>
										<div className='row'>
											<div className='col-md-12'>
												<label>
													Município:
													{' '}
													<Required />
												</label>
												<div className='form-group'>
													<SelectMulti
														isClearable={false}
														isMulti={false}
														name='municipio'
														uniqueKey='codigoIbge'
														label='nome'
														value={
															municipioSelecionado
														}
														onChange={(item) => {
															this.onChangeMunicipio(item);
															resetForm();
														}}
														options={municipios}
													/>
													<ErrorMessage
														name='municipio'
														render={msg => (
															<span className='text-danger'>
																{msg}
															</span>
														)}
													/>
												</div> {/* .form-group */}
											</div> {/* .col-md-12 */}
										</div> {/* row */}
										<div className='row'>
											<div className='col-md-12'>
												<label>
													Anexar ofício: <Required />
												</label>
											</div>
											<div className='container'>
												<UploadBrowseFile
													name='documento'
													files={files}
													required
													context={this}
													aspectRatio={0.1}
													expetedTypesLabel='Selecione arquivos de texto ou imagens'
													onUpload={this.handlePosUploadAction}
													handleUploadFile={UploadService.handleUploadFilePond}
													acceptedFileTypes={
														[
															'application/pdf',
															'application/msword',
															'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
															'image/png',
															'image/jpeg',
															'image/jpg',
															'image/bmp',
															'image/tiff',
														]
													}
												/>
											</div>
										</div>
									</React.Fragment>
								)
							}

							{/* EDIÇÃO DO OFICIO DE ENTIDADES */}
							{oficio.tipoOficio === 'entidade'
								&& (
									<React.Fragment>
										<div className='row'>
											<div className='col-md-12'>
												<label>
													Entidade:
													{' '}
													<Required />
												</label>
												<div className='form-group'>
													<SelectMulti
														isClearable={false}
														isMulti={false}
														name='entidade'
														label='nome'
														value={
															entidadeSelecionada
														}
														onChange={(item) => {
															this.onChangeEntidade(
																item,
															);
															resetForm();
														}}
														options={entidades}
													/>
													<ErrorMessage
														name='entidade'
														render={msg => (
															<span className='text-danger'>
																{msg}
															</span>
														)}
													/>
												</div> {/* .form-group */}
											</div> {/* .col-md-12 */}
										</div> {/* row */}

										{/*
											Condicional para saber se alguma entidade foi selecionada
										*/}
										{entidadeSelecionada !== null
											&& (
												<div>
													<div className='row'>
														<div className='col-md-6'>
															<strong>CNPJ:</strong>
															<p>{entidadeSelecionada.cnpj}</p>
														</div>
														<div className='col-md-6'>
															<strong>Telefone principal:</strong>
															<p>{
																formatarTelefone(entidadeSelecionada.telefonePrincipal)
															}
															</p>
														</div>
													</div>
													<div className='row'>
														<div className='col-md-6'>
															<strong>CEP:</strong>
															<p>{entidadeSelecionada.endereco.cep}</p>
														</div>
														<div className='col-md-6'>
															<strong>Município:</strong>
															<p>{entidadeSelecionada.endereco.municipio.nome}</p>
														</div>
													</div>
													<div className='row'>
														<div className='col-md-6'>
															<strong>Logradouro:</strong>
															<p>{entidadeSelecionada.endereco.logradouro}</p>
														</div>
														<div className='col-md-6'>
															<strong>Bairro:</strong>
															<p>{entidadeSelecionada.endereco.bairro}</p>
														</div>
													</div>
													<div className='row'>
														<div className='col-md-6'>
															<strong>Número:</strong>
															<p>{entidadeSelecionada.endereco.numero}</p>
														</div>
														<div className='col-md-6'>
															<strong>Complemento:</strong>
															<p>{entidadeSelecionada.endereco.complemento || '--'}</p>
														</div>
													</div>

												</div>
											)
										}

										{/* UPLOAD SEÇÃO ENTIDADES */}
										<div className='row'>
											<div className='col-md-12'>
												<label>
													Anexar ofício: <Required />
												</label>
											</div>
											<div className='container'>
												<UploadBrowseFile
													name='documento'
													files={files}
													required
													context={this}
													aspectRatio={0.1}
													expetedTypesLabel='Selecione arquivos de texto ou imagens'
													onUpload={this.handlePosUploadAction}
													handleUploadFile={UploadService.handleUploadFilePond}
													acceptedFileTypes={
														[
															'application/pdf',
															'application/msword',
															'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
															'image/png',
															'image/jpeg',
															'image/jpg',
															'image/bmp',
															'image/tiff',
														]
													}
												/>
												<ErrorMessage
													name='documento'
													render={msg => (
														<span className='text-danger'>
															{msg}
														</span>
													)}
												/>
											</div>
										</div>
									</React.Fragment>
								)
							}
						</React.Fragment>
					)}
				</ModalFormContext.Consumer>
			</WidgetModalForm>
		);
	}
}
